import { handleCartError } from "../helper";
export const validateCartBase = ({ client }) => async (cartId) => {
    const request = () => client.execute({
        method: "PUT",
        uri: `/ctp/carts/view/${cartId}`,
    });
    return handleCartError(request, 5);
};
